import { ShieldCheckIcon } from "@heroicons/react/24/solid";
import { FunnelIcon, PencilSquareIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import AddButton from "../../../../components/AddButton";
import ButtonForModal from "../../../../components/ButtonForModal";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useEmployees } from "../../Employees/Confie/hooks/useEmployees";
import {
  rowForEditSecurity,
  SecurityAddState,
  SecurityEditState,
  securityFromOffice,
  SecurityShowState,
  securityViewData,
  securityOfficeId,
  AlarmModalState,
  officeKeyModalState,
  DoorBuzzerModalState,
  recordNumberForEdit,
  CardReaderState,
  FireAlarmSystemModalState,
} from "../atoms/atoms";
import * as XLSX from "xlsx";
import { useSecurity } from "../hooks/useSecurity";
import { SecurityRowDetails } from "./SecurityViewDetails";
import { mainSelectedTab, paginationData } from "../../atoms";
import TableFilters from "../tableFilter";
import DownloadButton from "../../../../components/DownloadButton";
import useSecurityForDownload from "../hooks/useSecurityForDownload";
import { toast } from "../../../../components/toastNotification";
import { useCamerasAndLocation } from "../hooks/useCamerasAndLocation";
import { useGetSecurityForEdit } from "../hooks/useGetSecurityForEdit";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { ViewContainer } from "./ViewContainer";
import { useCameraTypes2 } from "../hooks/useCameraTypes2";
import { useCameraTypes1 } from "../hooks/useCameraTypes1";

interface SecurityTableProps {
  officeId?: string | number;
  viewFromOffice?: boolean;
}

export const SecurityTable: React.FC<SecurityTableProps> = ({
  officeId,
  viewFromOffice,
}) => {
  const tableRef = useRef(0);
  const [, setSelectedRecordNumber] = useRecoilState(recordNumberForEdit);
  const [isAdd, setIsAddState] = useRecoilState(SecurityAddState);
  const [isEdit, setIsEditState] = useRecoilState(SecurityEditState);
  const [isSearching, setIsSearching] = useState(false);
  const [reset, setReset] = useState(true);
  const [filter, setFilter] = useState(false);
  const [isShow, setShowState] = useRecoilState(SecurityShowState);
  const setRowToEdit = useSetRecoilState(rowForEditSecurity);
  const [caseNumber, setCaseNumber] = useState("");
  const [searchedSecurity, setSearchedSecurity] = useState<any[]>([]);
  const [filteredSecurity, setFilteredSecurity] = useState<any[]>([]);
  const [rowViewData, setRowViewData] = useRecoilState(securityViewData);
  const [page, setPage] = useRecoilState(paginationData);

  const [exportOffice, setExportOffice] = useState<any[]>([]);
  const [exportAlarm, setExportAlarm] = useState<any[]>([]);
  const [exportFireAlarmSystem, setExportFireAlarmSystem] = useState<any[]>([]);
  const [exportCamera, setExportCamera] = useState<any[]>([]);
  const [exportSafe, setExportSafe] = useState<any[]>([]);
  const [exportDoorBuzzer, setExportDoorBuzzer] = useState<any[]>([]);
  const [exportHvac, setExportHvac] = useState<any[]>([]);
  const [exportOfficeKey, setExportOfficeKey] = useState<any[]>([]);
  const [exportFilesImages, setExportFilesImages] = useState<any[]>([]);
  const [exportCardReader, setExportCardReader] = useState<any[]>([]);
  const [exportCardReaderGroup, setExportCardReaderGroup] = useState<any[]>([]);
  const [exportCardReaderAdmin, setExportCardReaderAdmin] = useState<any[]>([]);

  const [searchId, setSearchId] = useState("");
  const [ids, setIds] = useState<any[]>([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const security = useSecurity();
  const [clearFilter, setClearFilter] = useState(false);
  const [securityData, setSecurityData] = useState<any[]>([]);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [showFromOffice, setShowFromOffice] =
    useRecoilState(securityFromOffice);
  const [secOfficeId] = useRecoilState(securityOfficeId);
  const [, setIsFiltered] = useState(false);
  const [, setShowAlarmCardModal] = useRecoilState(AlarmModalState);
  const [, setShowCardReaderModal] = useRecoilState(CardReaderState);
  const [, setShowFireAlarmSystemCardModal] = useRecoilState(
    FireAlarmSystemModalState
  );
  const [, setShowOfficeKeysModal] = useRecoilState(officeKeyModalState);
  const [, setShowDoorBuzzerCardModal] = useRecoilState(DoorBuzzerModalState);
  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission = PERMISSIONS.permission_security_add;
  const editPermission = PERMISSIONS.permission_security_edit;
  let recordIdFromRecent;
  const history = useHistory();
  let location = useLocation();
  const downloadRef = useRef<{ link: HTMLAnchorElement }>();
  const { mutate: getSecurityDetails, isLoading: getSecurityDetailsLoading } =
    useSecurityForDownload();

  const { mutate: getSecurityForEdit, isLoading: securityLoading } =
    useGetSecurityForEdit();
  const search = location.search;
  const qs = new URLSearchParams(search);

  const qsId = qs.get("recordId");
  if (qsId && searchId === "") {
    setSearchId(qsId);
    setFilter(true);
    setIsSearching(true);
    setCaseNumber(qsId);
  }

  if (location.state !== null && location.state !== undefined) {
    recordIdFromRecent = location.state;
  }

  const { data: employees } = useEmployees();
  const employeeList = Array.isArray(employees)
    ? employees.map((x) => ({
        id: x.employeeId,
        value: x.employeeId?.toString(),
        label:
          x.firstname +
          (x.middlename ? " " + x.middlename + " " : " ") +
          x.lastname,
        email: x.email,
        status: x.status,
        manager: x.reportsToFullname,
        officeName: x.officeName,
        fullName:
          x.firstname +
          (x.middlename ? " " + x.middlename + " " : " ") +
          x.lastname,
      }))
    : [];

  const { data: camAndLocation } = useCamerasAndLocation();
  const camAndLocationOption = camAndLocation?.data?.map((x) => {
    return {
      id: x.id,
      value: x.id?.toString(),
      label: x.camerasAndLocation,
    };
  });

  const { data: camTypes1 } = useCameraTypes1();
  const camTypes1Option = camTypes1?.data?.map(
    (x: { id: number; cameraType1: string }) => {
      return {
        id: x.id,
        value: x.id,
        label: x.cameraType1,
      };
    }
  );

  const { data: camTypes2 } = useCameraTypes2();
  const camTypes2Option = camTypes2?.data?.map(
    (x: { id: number; cameraType2: string }) => {
      return {
        id: x.id,
        value: x.id,
        label: x.cameraType2,
      };
    }
  );

  useEffect(() => {
    if (searchId !== "") {
      try {
        notificationFilterById(searchId, "Security", null).then((result) => {
          setFilteredSecurity(result);
          setSearchId("");
          history.push("/officesettings/security");
        });
      } catch (error) {}
    }
  }, []);

  useEffect(() => {
    if (recordIdFromRecent) {
      setIsSearching(true);
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          null
        ).then((result) => {
          setFilteredSecurity(result);
          setSearchId("");
          setFilter(true);
          setCaseNumber(recordIdFromRecent.recordId);
          if (recordIdFromRecent.subModuleName === "EmpEdit") {
            handleEdit(result[0]);
            setIsEditState(true);
          }
          history.push("/officesettings/security");
        });
      } catch (error) {}
    } else {
      setFilteredSecurity([]);
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    if (recordIdFromRecent?.action === "VendorCancelToSecurityAlarm") {
      setShowState(true);
      setRowViewData(recordIdFromRecent.securityData);
      setShowAlarmCardModal(true);
    }
    if (recordIdFromRecent?.action === "VendorCancelToSecurityCardReader") {
      setShowState(true);
      setRowViewData(recordIdFromRecent.securityData);
      setShowCardReaderModal(true);
    } else if (
      recordIdFromRecent?.action === "VendorCancelToSecurityFireAlarmSystem"
    ) {
      setShowState(true);
      setRowViewData(recordIdFromRecent.securityData);
      setShowFireAlarmSystemCardModal(true);
    } else if (recordIdFromRecent?.action === "VendorCancelToSecurityOK") {
      setShowState(true);
      setRowViewData(recordIdFromRecent.securityData);
      setShowOfficeKeysModal(true);
    } else if (recordIdFromRecent?.action === "VendorCancelToSecurityDB") {
      setShowState(true);
      setRowViewData(recordIdFromRecent.securityData);
      setShowDoorBuzzerCardModal(true);
    }
  }, []);

  const handleEdit = (rowDetails) => {
    getSecurityForEdit(rowDetails.recordNumber, {
      onSuccess: (res) => {
        const fileCateg =
          res?.fileCategoryList === null
            ? []
            : res?.fileCategoryList?.map((file, index) => {
                return {
                  ...file,
                  fileCategory: file,
                  parentRow: index > 0 ? false : true,
                  tableName: "fileCategoryList",
                  fileName: res.fileName,
                };
              });
        setRowToEdit({
          ...res,
          fileCategoryList: [...fileCateg],
          fileCategoryListName: [...fileCateg],
          hvacinstallDate:
            res.hvacinstallDate === null
              ? null
              : res.hvacinstallDate?.slice(0, 10),
          installDate:
            res.installDate === null ? null : res.installDate?.slice(0, 10),
          contractRenewalDate:
            res.contractRenewalDate === null
              ? null
              : res.contractRenewalDate?.slice(0, 10),
          cameraInstallDate:
            res.cameraInstallDate === null
              ? null
              : res.cameraInstallDate?.slice(0, 10),
          alarmInstallDate:
            res.alarmInstallDate === null
              ? null
              : res.alarmInstallDate?.slice(0, 10),
        });
        if (!securityLoading) setIsEditState(true);
      },
    });
  };

  const onClickSecurity = (rowData) => {
    if (viewFromOffice) {
      setShowFromOffice(true);
      handleLink("security");
    }
    setShowState(true);
    setRowViewData(rowData);
  };

  const onClickCancelShow = () => {
    if (showFromOffice) {
      setShowFromOffice(false);
      handleLink("officesetting");
      setShowState(false);
    }
    setShowState(false);
    setSecurityData(securityData.map((data) => ({ ...data })));
    setFilteredSecurity([]);
    setSearchedSecurity([]);
    if (searchedSecurity?.length > 0) {
      setSearchedSecurity(searchedSecurity.map((search) => ({ ...search })));
    } else if (filteredSecurity?.length > 0) {
      setFilteredSecurity(filteredSecurity.map((filter) => ({ ...filter })));
    }
  };
  //Office View Filter
  useEffect(() => {
    if (security && security.data) {
      if (secOfficeId) {
        if (secOfficeId) {
          setIsFiltered(true);
          setFilteredSecurity(
            security?.data.data
              ?.filter((x) => x.officeId === secOfficeId)
              ?.map((data) => ({ ...data }))
          );
        } else {
          setSecurityData([]);
        }
      } else {
        setSecurityData(security?.data?.data.map((data) => ({ ...data })));
        setIsFiltered(false);
      }
    }
  }, [security.data]);

  //Function for View All button on Office View
  const onClickViewAll = () => {
    if (showFromOffice) {
      setShowFromOffice(false);
      handleLink("officesetting");
    }
    setShowState(false);
    setSecurityData(securityData.map((data) => ({ ...data })));
  };

  const handleLink = (moduleName) => {
    const url = `/officesettings/${moduleName}`;
    history.push(moduleName);
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };
  const [filterId, setFilterId] = useState<any[]>([]);

  useEffect(() => {
    if (filteredSecurity?.length > 0) {
      setFilterId(filteredSecurity?.map((x) => x.recordNumber));
    }
  }, [filteredSecurity]);

  // Download per section
  const exportSecurityData = () => {
    const scIds =
      searchedSecurity.length > 0
        ? ids
        : filteredSecurity?.length > 0
        ? filterId
        : security.data?.data?.map((x) => x.recordNumber);
    getSecurityDetails(scIds?.join(",").split(","), {
      onSuccess: (res) => {
        if (res) {
          // For office details
          setExportOffice(
            res[7]?.map((x) => {
              return {
                "Security Number": x.recordNumber
                  ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                  : "",
                "Office Name": x.officeName,
                "Office Code": x.officeCode,
                "Office Number": x.officeNumber,
                "Office Street": x.officeStreet,
                "Office City": x.officeCity,
                "Office State": x.officeState,
                "Office Zipcode": x.officeZipcode,
                "Office Brand": x.officeBrand,
                "Office Status": x.officeStatus,
              };
            })
          );
          // For alarm details
          setExportAlarm(
            res[0]?.map((x) => {
              {
                return {
                  "Security Number": x.recordNumber
                    ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                    : "",
                  "Alarm Vendor Name": x.vendorName,
                  "Alarm Vendor Phone":
                    x.vendorPhone !== "null" ? x.vendorPhone : "",
                  "Account Number": x.accountNumber,
                  "Contract Renewal Date": x.contractRenewalDate
                    ? new Date(x.contractRenewalDate)?.toLocaleDateString()
                    : "",

                  "Alarm Site Number": x.alarmSiteNumber,
                  "Data Connection": x.dataConnectionName,
                  "Connection Details": x.connectionDetails,
                  "Install Date": x.alarmInstallDate
                    ? new Date(x.alarmInstallDate)?.toLocaleDateString()
                    : "",
                  "IP Address": x.alarmIPAddress,
                  "IP Gateway": x.alarmIPGateway,
                  "Subnet Mask": x.alarmSubnet,
                  DNS: x.alarmDNS,
                  "Alarm Type": x.alarmTypeName,
                  "Number Of Motion Sensors": x.numberOfMotionSensors,
                  "Number Of Door Contact": x.numberOfDoorContacts,
                  "Number Of Panic Buttons": x.numberOfPanicButtons,
                  "Any Additional Special Equipment": x.specialEquipment,
                  "Cancellation Date": x.cancellationDate
                    ? new Date(x.cancellationDate)?.toLocaleDateString()
                    : "",
                  "Office Name": x.officeName,
                  "Office Code": x.officeCode,
                  "Office Number": x.officeNumber,
                  "Office Street": x.officeStreet,
                  "Office City": x.officeCity,
                  "Office State": x.officeState,
                  "Office Zipcode": x.officeZipcode,
                  "Created By": x.createdBy,
                  "Created Date": x.createdDate
                    ? new Date(x.createdDate)?.toLocaleDateString()
                    : "",
                  "Modified By": x.modifiedBy,
                  "Modified Date": x.modifiedDate
                    ? new Date(x.modifiedDate)?.toLocaleDateString()
                    : "",
                };
              }
            })
          );
          // For fire alarm system details
          setExportFireAlarmSystem(
            res[11]?.map((x) => {
              {
                return {
                  "Security Number": x.recordNumber
                    ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                    : "",
                  "Fire Alarm System Vendor Name": x.vendorName,
                  "Fire Alarm System Vendor Phone":
                    x.vendorPhone !== "null" ? x.vendorPhone : "",
                  "Account Number": x.vendorAccountNumber,
                  "Fire Alarm System Site Number": x.siteNumber,
                  "Data Connection": x.dataConnectionName,
                  "Connection Details": x.connectionDetails,
                  "Install Date": x.installDate
                    ? new Date(x.installDate)?.toLocaleDateString()
                    : "",
                  "IP Address": x.fireAlarmSystemIPAddress,
                  "IP Gateway": x.fireAlarmSystemIPGateway,
                  "Subnet Mask": x.fireAlarmSystemSubnet,
                  DNS: x.fireAlarmSystemDNS,
                  "Port Number": x.fireAlarmSystemPortNumber,
                  "Alarm Type": x.alarmTypeName,
                  "Number Of Fire Alarm Sensors": x.numberOfFireAlarmSensors,
                  "Number Of Floors": x.numberOfFloors,
                  "Phone Connection": x.phoneConnection,
                  "Any Additional Special Equipment": x.specialEquipment,
                  "Cancellation Date": x.cancellationDate
                    ? new Date(x.cancellationDate)?.toLocaleDateString()
                    : "",
                  "Office Name": x.officeName,
                  "Office Code": x.officeCode,
                  "Office Number": x.officeNumber,
                  "Office Street": x.officeStreet,
                  "Office City": x.officeCity,
                  "Office State": x.officeState,
                  "Office Zipcode": x.officeZipcode,
                  "Created By": x.createdBy,
                  "Created Date": x.createdDate
                    ? new Date(x.createdDate)?.toLocaleDateString()
                    : "",
                  "Modified By": x.modifiedBy,
                  "Modified Date": x.modifiedDate
                    ? new Date(x.modifiedDate)?.toLocaleDateString()
                    : "",
                };
              }
            })
          );
          // For camera details
          setExportCamera(
            res[1]?.flatMap((x) => {
              const CameraAndLocation = (x.cameraLocations || []).map((loc) => {
                const label = (loc.camerasAndLocationId || "")
                  .split(",")
                  .map((id) => {
                    const matched = camAndLocationOption?.find(
                      (option) => option.value === id.trim()
                    );
                    return matched?.label || id.trim();
                  })
                  .join(", ");

                const cameraType1Label =
                  camTypes1Option?.find(
                    (type) => type.value === loc.cameraType1
                  )?.label || "";

                const cameraType2Label =
                  camTypes2Option?.find(
                    (type) => type.value === loc.cameraType2
                  )?.label || "";

                return {
                  label,
                  cameraType1: cameraType1Label,
                  cameraType2: cameraType2Label,
                };
              });
              if (CameraAndLocation.length === 0) {
                return [
                  {
                    "Security Number": x.recordNumber
                      ? "S-" + String(x.recordNumber).padStart(4, "0")
                      : "",
                    "Number of cameras and Location": "",
                    "Camera Type 1": "",
                    "Camera Type 2": "",
                    "Camera Make": x.cameraMake,
                    "Camera Model": x.cameraModel,
                    "Install Date": x.cameraInstallDate
                      ? new Date(x.cameraInstallDate)?.toLocaleDateString()
                      : "",
                    "DVR Type": x.dvrtype,
                    "DVR Recording Max": x.dvrrecordingMax,
                    "Camera System": x.cameraSystem,
                    "Office Name": x.officeName,
                    "Office Code": x.officeCode,
                    "Office Number": x.officeNumber,
                    "Office Street": x.officeStreet,
                    "Office City": x.officeCity,
                    "Office State": x.officeState,
                    "Office Zipcode": x.officeZipcode,
                    "Created By": x.createdBy,
                    "Created Date": x.createdDate
                      ? new Date(x.createdDate)?.toLocaleDateString()
                      : "",
                    "Modified By": x.modifiedBy,
                    "Modified Date": x.modifiedDate
                      ? new Date(x.modifiedDate)?.toLocaleDateString()
                      : "",
                  },
                ];
              }

              return CameraAndLocation.map((item) => ({
                "Security Number": x.recordNumber
                  ? "S-" + String(x.recordNumber).padStart(4, "0")
                  : "",
                "Number of cameras and Location": item.label,
                "Camera Type 1": item.cameraType1 || "",
                "Camera Type 2": item.cameraType2 || "",
                "Camera Make": x.cameraMake,
                "Camera Model": x.cameraModel,
                "Install Date": x.cameraInstallDate
                  ? new Date(x.cameraInstallDate)?.toLocaleDateString()
                  : "",
                "DVR Type": x.dvrtype,
                "DVR Recording Max": x.dvrrecordingMax,
                "Camera System": x.cameraSystem,
                "IP Address": x.cameraIpAddress,
                "IP Gateway": x.ipGateway,
                "Subnet Mask": x.subnetMask,
                DNS: x.dns,
                "Office Name": x.officeName,
                "Office Code": x.officeCode,
                "Office Number": x.officeNumber,
                "Office Street": x.officeStreet,
                "Office City": x.officeCity,
                "Office State": x.officeState,
                "Office Zipcode": x.officeZipcode,
                "Created By": x.createdBy,
                "Created Date": x.createdDate
                  ? new Date(x.createdDate)?.toLocaleDateString()
                  : "",
                "Modified By": x.modifiedBy,
                "Modified Date": x.modifiedDate
                  ? new Date(x.modifiedDate)?.toLocaleDateString()
                  : "",
              }));
            })
          );

          // For safe details
          setExportSafe(
            res[2]?.map((x) => {
              {
                return {
                  "Security Number": x.recordNumber
                    ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                    : "",
                  "Safe Type": x.safeType,
                  "Is Safe Bolted to the Floor": x.isSafeBolted,
                  "Safe Model": x.safeModel,
                  "Safe Make": x.safeMake,
                  "Safe Serial Number": x.safeSerialNumber,
                  "Safe Location": x.safeLocation,
                  "Office Name": x.officeName,
                  "Office Code": x.officeCode,
                  "Office Number": x.officeNumber,
                  "Office Street": x.officeStreet,
                  "Office City": x.officeCity,
                  "Office State": x.officeState,
                  "Office Zipcode": x.officeZipcode,
                  "Created By": x.createdBy,
                  "Created Date": x.createdDate
                    ? new Date(x.createdDate)?.toLocaleDateString()
                    : "",
                  "Modified By": x.modifiedBy,
                  "Modified Date": x.modifiedDate
                    ? new Date(x.modifiedDate)?.toLocaleDateString()
                    : "",
                };
              }
            })
          );
          // For hvac details
          setExportHvac(
            res[3]?.map((x) => {
              {
                return {
                  "Security Number": x.recordNumber
                    ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                    : "",
                  "Number of Units": x.numberOfUnitsId,
                  "Unit Type": x.unitType,
                  "Ton Capacity": x.tonCapacity,
                  Make: x.make,
                  Model: x.model,
                  "Serial Number": x.serialNumber,
                  "Warranty Compressor": x.warrantyCompressor,
                  "Warranty Labor": x.warrantyLabor,
                  "HVAC Install Date": x.hvacinstallDate
                    ? new Date(x.hvacinstallDate)?.toLocaleDateString()
                    : "",
                  "Preventive Maintenance Plan": x.preventiveMaintenancePlan,
                  "Maintenance Company": x.maintenanceCompany,
                  "Requires Maintenance": x.requiresMaintenanceName,
                  "First Maintenance Date": x.firstMaintenanceDate
                    ? new Date(x.firstMaintenanceDate)?.toLocaleDateString()
                    : "",
                  "Maintenance Periodicity": x.maintenancePeriodicity,
                  "Office Name": x.officeName,
                  "Office Code": x.officeCode,
                  "Office Number": x.officeNumber,
                  "Office Street": x.officeStreet,
                  "Office City": x.officeCity,
                  "Office State": x.officeState,
                  "Office Zipcode": x.officeZipcode,
                  "Created By": x.createdBy,
                  "Created Date": x.createdDate
                    ? new Date(x.createdDate)?.toLocaleDateString()
                    : "",
                  "Modified By": x.modifiedBy,
                  "Modified Date": x.modifiedDate
                    ? new Date(x.modifiedDate)?.toLocaleDateString()
                    : "",
                };
              }
            })
          );
          // For door buzzer details
          setExportDoorBuzzer(
            res[4]?.map((x) => {
              {
                return {
                  "Security Number": x.recordNumber
                    ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                    : "",
                  "Site Number": x.siteNumber,
                  Connection: x.connection,
                  "Install Date": x.dbInstallDate
                    ? new Date(x.dbInstallDate)?.toLocaleDateString()
                    : "",
                  Type: x.type,
                  "# of Button Select List": x.numberOfButtonSelectedId,
                  Warranty: x.warranty,
                  "Warranty Length": x.warrantyLength,
                  "Warranty Coverage": x.warrantyCoverage,
                  "Install Type Vendor Name": x.dbinstallVendorName,
                  "Install Type Vendor Contact": x.dbInstallVendorContact,
                  "Install Type Vendor Address": x.dbinstallVendorAddress,
                  "Install Type Vendor Phone":
                    x.dbinstallVendorPhone !== "null"
                      ? x.dbinstallVendorPhone
                      : "",
                  "Warranty Type Vendor Name": x.dbWarrantyVendorName,
                  "Warranty Type Vendor Contact": x.dbWarrantyVendorContact,
                  "Warranty Type Vendor Address": x.dbWarrantyVendorAddress,
                  "Warranty Type Vendor Phone":
                    x.dbWarrantyVendorPhone !== "null"
                      ? x.dbWarrantyVendorPhone
                      : "",
                  "Servicing Type Vendor Name": x.dbServicingVendorName,
                  "Servicing Type Vendor Contact": x.dbServicingVendorContact,
                  "Servicing Type Vendor Address": x.dbServicingVendorAddress,
                  "Servicing Type Vendor Phone":
                    x.dbServicingVendorPhone !== "null"
                      ? x.dbServicingVendorPhone
                      : "",
                  "Office Name": x.officeName,
                  "Office Code": x.officeCode,
                  "Office Number": x.officeNumber,
                  "Office Street": x.officeStreet,
                  "Office City": x.officeCity,
                  "Office State": x.officeState,
                  "Office Zipcode": x.officeZipcode,
                  "Created By": x.createdBy,
                  "Created Date": x.createdDate
                    ? new Date(x.createdDate)?.toLocaleDateString()
                    : "",
                  "Modified By": x.modifiedBy,
                  "Modified Date": x.modifiedDate
                    ? new Date(x.modifiedDate)?.toLocaleDateString()
                    : "",
                };
              }
            })
          );
          // For office key details
          setExportOfficeKey(
            res[5]?.map((x) => {
              {
                const keysValue = x.keysAssignedTo?.split(",");

                const filteredValue = keysValue?.map((x) =>
                  employeeList?.filter((b) => b?.value === x)
                );

                const keysAssigned = filteredValue?.map(
                  (x) => x?.map((x) => x)[0]
                );
                return {
                  "Security Number": x.recordNumber
                    ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                    : "",
                  "Locksmith Vendor": x.lockSmithVendor,
                  "Office Key Vendor Address": x.okvendorAddress,
                  "Office Key Vendor Phone":
                    x.okvendorPhone !== "null" ? x.okvendorPhone : "",
                  "# of Keys": x.numberOfKeys,
                  "Keys Assigned To": x.keysAssignedTo
                    ? keysAssigned?.map((x) => x?.label)?.join(", ")
                    : null,
                  "Key Type": x.keyType,
                  "Key Coding Model": x.keyCodingModel,
                  "Office Name": x.officeName,
                  "Office Code": x.officeCode,
                  "Office Number": x.officeNumber,
                  "Office Street": x.officeStreet,
                  "Office City": x.officeCity,
                  "Office State": x.officeState,
                  "Office Zipcode": x.officeZipcode,
                  "Created By": x.createdBy,
                  "Created Date": x.createdDate
                    ? new Date(x.createdDate)?.toLocaleDateString()
                    : "",
                  "Modified By": x.modifiedBy,
                  "Modified Date": x.modifiedDate
                    ? new Date(x.modifiedDate)?.toLocaleDateString()
                    : "",
                };
              }
            })
          );
          // For files and images details
          setExportFilesImages(
            res[6]?.map((x) => {
              {
                return {
                  "Security Number": x.securityRecordNumber
                    ? "S-" + String(x.securityRecordNumber)?.padStart(4, "0")
                    : "",
                  "Security File Names": x.securityFileName,
                  "File Category": x.securityFileCategory,
                  "Office Name": x.officeName,
                  "Office Code": x.officeCode,
                  "Office Number": x.officeNumber,
                  "Office Street": x.officeStreet,
                  "Office City": x.officeCity,
                  "Office State": x.officeState,
                  "Office Zipcode": x.officeZipcode,
                  "Created By": x.createdBy,
                  "Created Date": x.createdDate
                    ? new Date(x.createdDate)?.toLocaleDateString()
                    : "",
                  "Modified By": x.modifiedBy,
                  "Modified Date": x.modifiedDate
                    ? new Date(x.modifiedDate)?.toLocaleDateString()
                    : "",
                };
              }
            })
          );

          setExportCardReader(
            res[8]?.map((x) => {
              {
                return {
                  "Security Number": x.recordNumber
                    ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                    : "",
                  "Card Reader Vendor Name": x.vendorName,
                  "Vendor Phone": x.vendorPhone !== "null" ? x.vendorPhone : "",
                  "Account Number Brivo": x.accountNumberBrivo,
                  "Account Number Billing": x.accountNumberBilling,
                  "Confie Site Number": x.confieSiteNumber,
                  "Brivo Site Number": x.brivoSiteNumber,
                  "Vendor CS": x.vendorCS,
                  "Data Connection Equipment": x.dataConnectionEquipment,
                  "Data Connection Port": x.dataConnectionPort,
                  "IP Address Setting Option": x.ipAddressSettingOption,
                  "IP Address": x.ipAddress,
                  "Install Date": x.installDate
                    ? new Date(x.installDate)?.toLocaleDateString()
                    : "",
                  "Cancellation Date": x.cancellationDate
                    ? new Date(x.cancellationDate)?.toLocaleDateString()
                    : "",
                  IsWarranty: x.isWarranty,
                  "Warranty Coverage": x.warrantyCoverage,
                  "Additional Description": x.additionalDescription,
                  "Coverage Start Date": x.coverageStartDate
                    ? new Date(x.coverageStartDate)?.toLocaleDateString()
                    : "",
                  "Coverage End Date": x.coverageEndDate
                    ? new Date(x.coverageEndDate)?.toLocaleDateString()
                    : "",
                  "Card Type": x.cardType,
                  "Is Key Card Access": x.isKeyCardAccess,
                  "Parking Card Format": x.parkingCardFormat,
                  "Parking Site Number": x.parkingSiteNumber,
                  "Card Name": x.cardName,
                  "Card Company Name": x.cardCompanyName,
                  "Card Address": x.cardAddress,
                  "Card Hours": x.cardHours,
                  "Card Email Address": x.cardEmailAddress,

                  "Office Name": x.officeName,
                  "Office Code": x.officeCode,
                  "Office Number": x.officeNumber,
                  "Office Street": x.officeStreet,
                  "Office City": x.officeCity,
                  "Office State": x.officeState,
                  "Office Zipcode": x.officeZipcode,
                  "Created By": x.createdBy,
                  "Created Date": x.createdDate
                    ? new Date(x.createdDate)?.toLocaleDateString()
                    : "",
                  "Modified By": x.modifiedBy,
                  "Modified Date": x.modifiedDate
                    ? new Date(x.modifiedDate)?.toLocaleDateString()
                    : "",
                };
              }
            })
          );
          setExportCardReaderGroup(
            res[10]?.map((x) => {
              return {
                "Security Number": x.recordNumber
                  ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                  : "",
                "Card Reader Vendor Name": x.vendorName,
                "Vendor Phone": x.vendorPhone !== "null" ? x.vendorPhone : "",
                "Group Title": x.groupTitle,
                "Staff Group": x.staffGroup,
                "Monday Hours": x.monday_Hours,
                "Tuesday Hours": x.tuesday_Hours,
                "Wednesday Hours": x.wednesday_Hours,
                "Thursday Hours": x.thursday_Hours,
                "Friday Hours": x.friday_Hours,
                "Saturday Hours": x.saturday_Hours,
                "Sunday Hours": x.sunday_Hours,
                "Group Doors": x.doors,

                "Created By": x.createdBy,
                "Created Date": x.createdDate
                  ? new Date(x.createdDate)?.toLocaleDateString()
                  : "",
                "Modified By": x.modifiedBy,
                "Modified Date": x.modifiedDate
                  ? new Date(x.modifiedDate)?.toLocaleDateString()
                  : "",
              };
            })
          );

          setExportCardReaderAdmin(
            res[9]?.map((x) => {
              {
                return {
                  "Security Number": x.recordNumber
                    ? "S-" + String(x.recordNumber)?.padStart(4, "0")
                    : "",
                  "Card Reader Vendor Name": x.vendorName,
                  "Vendor Phone": x.vendorPhone !== "null" ? x.vendorPhone : "",
                  "Full Name": x.name,
                  "Phone Number": x.phoneNumber,
                  "Email Address": x.email,
                  "Is Master": x.isMasterAdmin,

                  "Created By": x.createdBy,
                  "Created Date": x.createdDate
                    ? new Date(x.createdDate)?.toLocaleDateString()
                    : "",
                  "Modified By": x.modifiedBy,
                  "Modified Date": x.modifiedDate
                    ? new Date(x.modifiedDate)?.toLocaleDateString()
                    : "",
                };
              }
            })
          );
        }
        // Toaster on Success
        downloadRef.current?.link.click();
        toast.fire(
          "Download Security ",
          "Successfully downloaded security.",
          "success"
        );
        setIsSuccess(true);
      },
      // Toaster on Error
      onError: (error) => {
        if (error) {
          toast.fire(
            "Download Security ",
            "Server Error: Cannot download security.",
            "error"
          );
        }
      },
    });
  };

  useEffect(() => {
    if (isSuccess) {
      // For getting security details
      const office = XLSX.utils.json_to_sheet(exportOffice);
      const alarm = XLSX.utils.json_to_sheet(exportAlarm);
      const camera = XLSX.utils.json_to_sheet(exportCamera);
      const card = XLSX.utils.json_to_sheet(exportCardReader);
      const fireAlarmSystem = XLSX.utils.json_to_sheet(exportFireAlarmSystem);
      const cardGroup = XLSX.utils.json_to_sheet(exportCardReaderGroup);
      const cardAdmin = XLSX.utils.json_to_sheet(exportCardReaderAdmin);
      const safe = XLSX.utils.json_to_sheet(exportSafe);
      const hvac = XLSX.utils.json_to_sheet(exportHvac);
      const doorBuzzer = XLSX.utils.json_to_sheet(exportDoorBuzzer);
      const officeKey = XLSX.utils.json_to_sheet(exportOfficeKey);
      const filesImages = XLSX.utils.json_to_sheet(exportFilesImages);

      const wb = XLSX.utils.book_new();

      // For additional sheet in excel
      XLSX.utils.book_append_sheet(wb, office, "Main Section");
      XLSX.utils.book_append_sheet(wb, alarm, "Alarm Section");
      XLSX.utils.book_append_sheet(wb, camera, "Camera Section");
      XLSX.utils.book_append_sheet(wb, card, "Card Reader Section");
      XLSX.utils.book_append_sheet(
        wb,
        cardGroup,
        "Card Reader Group Info Section"
      );
      XLSX.utils.book_append_sheet(wb, cardAdmin, "Card Reader Admin Section");
      XLSX.utils.book_append_sheet(
        wb,
        fireAlarmSystem,
        "Fire Alarm System Section"
      );

      XLSX.utils.book_append_sheet(wb, safe, "Safe Details Section");
      XLSX.utils.book_append_sheet(wb, doorBuzzer, "Door Buzzer Section");
      XLSX.utils.book_append_sheet(wb, officeKey, "Office Keys Section");
      XLSX.utils.book_append_sheet(wb, hvac, "HVAC Section");

      XLSX.utils.book_append_sheet(wb, filesImages, "Files and Images Section");
      XLSX.writeFile(
        wb,
        "SecurityDownloadedFile_" + new Date()?.toLocaleDateString() + ".xlsx"
      );
      setIsSuccess(false);
    }
  }, [isSuccess]);

  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;

  const matColumns = [
    {
      title: "Security Number",
      field: "recordNumber",
      render: (rowdata) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              onClickSecurity(rowdata);
              const recordNumber = rowdata.recordNumber;
              setSelectedRecordNumber(recordNumber);
            }}
          >
            <span className="blueAndBold underline">
              {"S-" + String(rowdata.recordNumber)?.padStart(4, "0")}
            </span>
            <br></br>
          </div>
        );
      },
    },
    {
      title: "Office Name",
      field: "officeName",
      sorting: false,
    },
    {
      title: "Office State",
      field: "officeState",
      sorting: false,
    },
    {
      title: "Office Brand",
      field: "officeBrand",
      sorting: false,
    },
    {
      title: "Office Status",
      field: "officeStatus",
      sorting: false,
    },
    {
      title: "Actions",
      name: "Action/s",
      align: alignCenter,
      render: (rowData) => {
        return userPermissions.includes(editPermission) ? (
          <div className="flex place-content-center mr-4">
            <ButtonForModal
              className={
                rowData?.status?.includes("Closed")
                  ? "border border-quaternary text-white bg-quaternary opacity-50"
                  : "border border-quaternary text-white bg-quaternary"
              }
              onClick={() => {
                handleEdit(rowData);
                const recordNumber = rowData.recordNumber;
                setSelectedRecordNumber(recordNumber);
              }}
              isDisabled={false}
            >
              <PencilSquareIcon className="h-4 w-4" />
              Edit
            </ButtonForModal>
          </div>
        ) : (
          ""
        );
      },
    },
  ];

  const oldValues = {
    Account: "",
    CaseNumber: "",
    Contact: "",
    CreatedBy: "",
    CreatedDate: "",
    Status: "",
    ActionRequiredOrNotificationC: "",
  };

  let prevPage = new URLSearchParams(window.location.search).get("prevPage");
  useEffect(() => {
    if (prevPage !== null && isAdd) {
      setPage(page);
    } else if (prevPage !== null && isEdit) {
      setPage(page);
    } else if (prevPage !== null && isShow) {
      setPage(page);
    } else if (prevPage !== null && tableRef.current !== Number(prevPage)) {
      tableRef.current = page;
    }
  });

  const [oldFilteredValue] = useState(oldValues);
  return (
    <>
      <div className=" px-8 py-4 min-h-fit min-h-fit ">
        {isAdd === true || isEdit === true ? (
          <ViewContainer />
        ) : isShow ? (
          <div
            className={
              !viewFromOffice
                ? "relative px-2 py-2 box-shadow border-quinary border-l-2"
                : "relative py-2 box-shadow"
            }
          >
            <SecurityRowDetails
              viewFromOffice={viewFromOffice}
              onClickViewAll={onClickViewAll}
              // filesCategory={res}
              rowData={rowViewData}
              rowIsExpanded={true}
              handleEdit={handleEdit}
              onClickCancelShow={onClickCancelShow}
              setIsAdd={setIsAddState}
              setReset={false}
            />
          </div>
        ) : (
          <div className="">
            {!viewFromOffice ? (
              <>
                <div className="flex gap-2 items-center">
                  <div>
                    <ShieldCheckIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                  </div>
                  <div className="flex flex-col leading tight">
                    <h3 className="text-xs font-medium text-gray-500">
                      Security Module
                    </h3>
                    <h1 className="mr-auto font-bold text-primary text-md uppercase">
                      All Securities
                    </h1>
                  </div>
                </div>
              </>
            ) : null}
            <div className="pt-4 pb-2 flex justify-between">
              {isAdd || isEdit || isShow ? (
                ""
              ) : (
                <div className="space-x-4">
                  <button
                    className="hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs 
                    gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
                    onClick={() => {
                      setFilter(!filter);
                    }}
                  >
                    <div>Filter By</div>
                    <FunnelIcon className="h-3 w-3 focus:bg-primary" />
                  </button>
                </div>
              )}
              <div className="flex items-center">
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    className={"opacity-100"}
                    disabled={false}
                    buttonText="Add"
                    onClick={() => {
                      setIsAddState(true);
                    }}
                  />
                ) : (
                  ""
                )}
                <div className="ml-2">
                  <DownloadButton
                    disabled={
                      getSecurityDetailsLoading ||
                      isEdit ||
                      (searchedSecurity?.length === 0 && reset === false)
                    }
                    buttonValue={
                      getSecurityDetailsLoading
                        ? "Downloading..."
                        : "Download File"
                    }
                    onClick={() => exportSecurityData()}
                    className={undefined}
                  />
                </div>
              </div>
            </div>
            <main className="flex flex-row">
              {isAdd || isEdit || isShow
                ? ""
                : filter && (
                    <div className="w-1/4 bg-white pb-4">
                      <div className="mb-4">
                        {
                          <TableFilters
                            setCaseNumberValue={caseNumber}
                            setFilteredSecurity={setFilteredSecurity}
                            setSearchedSecurity={setSearchedSecurity}
                            isSearching={isSearching}
                            setIsSearching={setIsSearching}
                            clearFilter={clearFilter}
                            setClearFilter={setClearFilter}
                            setReset={setReset}
                            setIds={setIds}
                          />
                        }
                      </div>
                    </div>
                  )}
              <div
                className={
                  !filter || isShow
                    ? "w-full bg-white overflow-x-auto box-shadow"
                    : "w-full h-5/6 bg-white p-4 overflow-x-auto "
                }
              >
                <div className="grid grid-row">
                  <MaterialExTable
                    data={
                      filteredSecurity?.length > 0
                        ? filteredSecurity
                        : searchedSecurity?.length > 0
                        ? searchedSecurity
                        : reset
                        ? securityData
                        : []
                    }
                    columns={matColumns}
                    isLoading={security.isLoading}
                    tableRef={tableRef}
                    search={viewFromOffice ? false : true}
                    searchFieldAlignment={"left"}
                    toolbar={false}
                    showTitle={false}
                    exportButton={false}
                    title={"Security_" + new Date().toLocaleDateString()}
                    actions={undefined}
                    editable={undefined}
                    grouping={undefined}
                    detailPanel={undefined}
                    selection={undefined}
                    onSelectionChange={undefined}
                    setOpenModal={undefined}
                    toolBarComponent={undefined}
                    panelWidth={undefined}
                    onSearchChange={undefined}
                    fileName={undefined}
                  />
                </div>
              </div>
            </main>
          </div>
        )}
      </div>
    </>
  );
};
